import * as React from 'react';
import style from './Assistent.less';
import { AssistentItem, AssistentCustomFormItem } from './assistent_config';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import { renderText } from './assistent_helpers';

interface AssistentCustomFormProps extends React.ClassAttributes<any> {
    item: AssistentItem;
    datenhaltung: any;
    onDatenhaltungChange: (datenhaltung: any) => void;
    data: any;
}

interface AssistentCustomFormState {
    dummy?: any;
}

export class AssistentCustomForm extends React.Component<AssistentCustomFormProps, AssistentCustomFormState> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        // Presets setzen, aber nur wenn die Daten noch nicht da sind
        const item = this.props.item;
        const daten = this.props.datenhaltung;
        let hasChange = false;
        item.customFormItems.forEach((cfi: AssistentCustomFormItem) => {
            // Achtung, hier wirklich auf undefined prüfen, da "false" ein Wert sein kann
            if (daten[cfi.key] === undefined && cfi.preset !== undefined) {
                daten[cfi.key] = cfi.preset;
                hasChange = true;
            }
        });
        if (hasChange) {
            this.props.onDatenhaltungChange(daten);
        }
    }

    render(): JSX.Element {
        const item = this.props.item;
        return (
            <div
                className={style.customForm}
            >
                {item.infoTextKey && <div className={style.customFormInfotext}>
                    {item.infoTextKey && renderText(item.infoTextKey, this.props.data)
                    }</div>}
                <div className={style.customFormTitel}>{item.description}</div>
                {item.customFormItems.map((cfi: AssistentCustomFormItem, idx: number) => this.renderFormItem(cfi, idx))}
            </div>
        );
    }
    renderFormItem(cfi: AssistentCustomFormItem, idx: number) {
        return <div
            className={style.customFormField}
            key={'cfi_' + idx}
        >
            <div className={style.customFormFieldText}>
                <div>{cfi.question}</div>
                <div>{cfi.helpIconKey && this.renderHelpIcon(cfi.helpIconKey)}</div>
            </div>
            <div className={style.customFormFieldInput}>{this.renderFormInput(cfi)}</div>
        </div>;
    }

    renderFormInput(cfi: AssistentCustomFormItem) {
        return <React.Fragment>
            {cfi.type === 'checkbox' &&
                <input
                    disabled={cfi.disabled}
                    type='checkbox'
                    checked={this.props.datenhaltung[cfi.key] || false}
                    onChange={(evt: any) => this.setValue(cfi, evt.target.checked)}
                />}
        </React.Fragment>;
    }
    setValue(cfi: AssistentCustomFormItem, value: any) {
        //  console.log('set', cfi, value);
        const key = cfi.key;
        const daten = this.props.datenhaltung;
        daten[key] = value;
        this.props.onDatenhaltungChange(daten);
    }
    renderHelpIcon(helpKey: string): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block', marginRight: '0.5em' }}
                styleProps={{
                    width: '18px', height: '18px', borderRadius: '10px', backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0
                }}
                label='Hinweise zu diesem Feld'
                helpKey={helpKey}
                type={'info'}
                editBar={true}
            />
        );
    }
}
